import React, { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SpaPropsContext = /*#__PURE__*/createContext({});
const SpaPropsProvider = _ref => {
  let {
    children,
    spaProps
  } = _ref;
  return /*#__PURE__*/_jsx(SpaPropsContext.Provider, {
    value: {
      spaProps
    },
    children: children
  });
};
export const useSpaPropsContext = () => useContext(SpaPropsContext);
export default SpaPropsProvider;